import { Routes } from '@angular/router';
import { authGuard, roleGuard, externalUserGuard } from '#core';
import { PermissionActions, PermissionResources } from '#enums';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../shared-components/master-layout/master-layout').then(m => m.MasterLayout),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'asset-inventory', pathMatch: 'full' },
      {
        path: 'asset-inventory',
        loadChildren: () =>
          import('../features/asset-inventory/asset-inventory.routes').then(m => m.ASSET_INVENTORY_ROUTES),
        canActivate: [roleGuard('Assets', 'CanView')],
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('../features/projects/projects.routes').then(m => m.PROJECTS_ROUTES),
        canActivate: [roleGuard('Projects', 'CanView')],
      },
      {
        path: 'remediation',
        loadChildren: () =>
          import('../features/remediation/remediation.routes').then(m => m.REMEDIATION_ROUTES),
        canActivate: [roleGuard(PermissionResources.Remediation, PermissionActions.CanView)],
      },
      {
        path: 'search',
        loadChildren: () =>
          import('../features/search/search.routes').then(m => m.SEARCH_ROUTES),
        canActivate: [roleGuard('Assets', 'CanView')],
      },
      {
        path: 'cost-control',
        loadChildren: () =>
          import('../features/cost-control/cost-control.routes').then(m => m.COST_CONTROL_ROUTES),
        canActivate: [roleGuard('CostControl', 'CanView')],
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('../features/admin/admin.routes').then(m => m.ADMIN_ROUTES),
        canActivate: [externalUserGuard, roleGuard('Admin', 'CanAccess')],
      },
    ],
  },
  {
    // MSAL authorization code redirect target — processes the auth code silently.
    path: 'auth',
    loadComponent: () => import('../features/auth/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('../features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('../features/errors/unauthorized/unauthorized').then(m => m.Unauthorized),
  },
  {
    path: 'forbidden',
    loadComponent: () => import('../features/errors/forbidden/forbidden').then(m => m.Forbidden),
  },
  {
    path: 'not-found',
    loadComponent: () => import('../features/errors/not-found/not-found').then(m => m.NotFound),
  },
  {
    path: 'account-pending',
    loadComponent: () => import('../features/errors/account-pending/account-pending').then(m => m.AccountPending),
  },
  { path: '**', loadComponent: () => import('../features/errors/not-found/not-found').then(m => m.NotFound) },
];
